import React from 'react'

function PageLayout(props) {
  return (

    <>
      <div className="row mt-2">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="row align-items-center justify-content-center flex-wrap px-2 ">
                <div className="col-xl-6 mb-1">
                  <div className="d-flex justify-content-center justify-content-xl-start">
                    {props.title && <h4>{props.title}</h4>}
                  </div>
                </div>
                <div className="col-xl-6 mb-0">
                  <div className={props.title2cls || "d-flex align-content-center justify-content-center justify-content-xl-end flex-wrap flex-lg-nowrap"}>
                    {props.title2 && 
                    <h4>{props.title2}</h4>
                    }
                    {props.button}
                    {props.atag}
                  </div>
                </div>
              </div>
              {props.listing && props.children}
            </div>
            {props.page && props.children}
          </div>
          
        </div>
      </div>

    </>
  )
}

export default PageLayout